'use strict';

import { easeOutExpo, sanitize } from "../../../_js/common/_util";

export default class Accordion {
    constructor() {
        const $accordionTitle = $('.paragraph--type--accordion .field--name-field-title');
        const $accordionBody = $('.paragraph--type--accordion .field--name-field-accordion-body');

        $accordionTitle.each(function (i, v) {
            const $this = $(v);

            $this.attr('name', sanitize($this.text()))
        }).on('click', function (e) {
            e.preventDefault();

            const $this = $(this);

            $this.toggleClass('-active');
            $this.next().stop().clearQueue().slideToggle(easeOutExpo);
            window.location.hash = $this.attr('name');
        });

        $('.-js-toggle-accordions').on('click', function (e){
            e.preventDefault();

            const $this = $(this);

            $this.toggleClass('-active');


            if ($this.hasClass('-active')) {
                $this.text('Collapse all');
                $accordionTitle.addClass('-active');
                $accordionBody.stop().clearQueue().slideDown(easeOutExpo);
            } else {
                $this.text('Expand all');
                $accordionTitle.removeClass('-active');
                $accordionBody.stop().clearQueue().slideUp(easeOutExpo);
            }
        });

        if ($accordionTitle && window.location.hash) {
            let hashValue = window.location.hash.replace('#', '');
            let $accordionTitle = $('.paragraph--type--accordion .field--name-field-title[name="' + hashValue + '"]');

            $accordionTitle.trigger('click');

            $('html, body').animate({ scrollTop: $accordionTitle.position().top }, {
                duration: 1500,
                easing: 'easeInOutExpo'
            });
        }
    }
}
